import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import editorActionPendingMixin from 'next/javascripts/mixins/editor-action-pending-mixin';
import editorDraftMixin from 'next/javascripts/mixins/editor-draft-mixin';
import autosize from 'autosize';
import 'next/stylesheets/components/document-editor.scss';

Component('tr-document-editor', {
  mixins: [eventListenerMixin, editorActionPendingMixin, editorDraftMixin],

  properties: {
    markdown: {
      type: Boolean,
      default: false,
    },

    heartbeatUrl: {
      type: String,
    },
  },

  ready() {
    document.body.classList.add('body-document-editor');
    this.titleField = this.querySelector('.document-editor-title');

    this.listenTo(
      this.querySelector('tr-editor'),
      'tr-editor:editorReady',
      this.handleEditorLoaded.bind(this),
    );

    this.listenTo(
      this.querySelector('tr-markdown-editor'),
      'tr-markdown-editor:editorReady',
      this.handleEditorLoaded.bind(this),
    );

    this.header = this.querySelector('.document-editor-header');
    this.main = this.querySelector('.document-editor-main');
    this.listenTo(this.main, 'scroll', () => {
      this.header.classList.toggle('active', this.main.scrollTop > 24);
    });

    const link = this.querySelector('.link-back');
    this.listenTo(link, 'click', (event) => {
      event.stopPropagation();
      event.preventDefault();
      this.close({ redirectUrl: link.href });
    });

    this.listenTo(this.titleField, 'keydown', (event) => {
      const isEnter = event.key === 'Enter' || event.keyCode === 13;
      if (isEnter) {
        event.stopPropagation();
        event.preventDefault();
      }
    });
    autosize(this.titleField);
    if (this.heartbeatUrl) setInterval(() => this.heartbeat(), 30000);
  },

  handleEditorLoaded(event) {
    const { editor } = event.detail;
    this.editor = editor;

    let toolbar;
    if (editor.ui) {
      toolbar = editor.ui.view.toolbar.element;
    } else if (editor.gui) {
      ({ toolbar } = editor.gui);
    }

    const element = this.querySelector('.header-center');
    element.innerHTML = '';
    element.appendChild(toolbar);
    this.listenTo(window, 'keydown', this.handleKeydown.bind(this));

    if (!this.markdown) this.initDocumentToc(editor);
    event.target.focus();
  },

  initDocumentToc(editor) {
    const documentToc = this.querySelector('tr-document-toc');
    if (!documentToc) return;

    documentToc.update();

    editor.model.document.on('change:data', () => {
      const changes = editor.model.document.differ.getChanges();
      this.shouldUpdateDocumentToc = changes.some(({ name, position }) => (
        /^heading\d/.test(name) || (
          name === '$text' && position.parent && /^heading\d/.test(position.parent.name)
        )
      ));
    });

    editor.editing.view.on('render', () => {
      if (this.shouldUpdateDocumentToc) {
        documentToc.update();
        this.shouldUpdateDocumentToc = false;
      }
    });
  },

  handleKeydown(event) {
    const isKeyS = event.key === 's' || event.keyCode === 83;
    if ((event.metaKey || event.ctrlKey) && isKeyS) {
      event.stopPropagation();
      event.preventDefault();

      const { titleField, editor } = this;
      const data = { [titleField.name]: titleField.value };
      if (editor.sourceElement) {
        Object.assign(data, { [editor.sourceElement.name]: editor.getData() });
      } else if (editor.element) {
        Object.assign(data, { [editor.element.name]: editor.element.value });
      }
      this.updateDraft(data);
    }
  },

  heartbeat() {
    $.ajax({
      url: this.heartbeatUrl,
      type: 'post',
      dataType: 'json',
    });
  },

  close({ redirectUrl }) {
    if (window.opener) {
      const selector = `tr-document-edit-button[name="${window.name}"]`;
      const button = window.opener.document.querySelector(selector);
      if (button) {
        button.closeEditWindow({ redirectUrl });
        return;
      }
    }
    window.location.href = redirectUrl;
  },

  disconnected() {
    if (this.heartbeatTimer) clearInterval(this.heartbeatTimer);
    this.stopListening();
    document.body.classList.remove('body-document-editor');
  },
});
